module.exports = __webpack_public_path__ + "static/img/row5.9332adc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark-mini/row5.png
// module id = p8pB
// module chunks = 12